var Scope;!function(i){i.Visit="visit",i.Visitor="visitor"}(Scope=Scope||{});export{Scope};